<div class="footer">
  <div class="container">
    <span>
       &copy; {{ today | date: 'yyyy' }} SoftDiamond
    </span>
  </div>
</div>